/* function resetCartCheckoutButtons() {
  document
    .querySelectorAll('#CartDrawer-Checkout, button[name="checkout"][form="CartDrawer-Form"]')
    .forEach((btn) => {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      btn.querySelector('.loading__spinner')?.classList.add('hidden');
    });

  const drawer = document.querySelector('cart-drawer');
  const checkout = document.getElementById('CartDrawer-Checkout');
  if (drawer?.classList.contains('is-empty') && checkout) {
    checkout.disabled = true;
  }
} */

  function resetCartCheckoutButtons() {
  const checkoutSelectors = [
    '#CartDrawer-Checkout',
    'button[name="checkout"][form="CartDrawer-Form"]',
    '#checkout',
    'button[name="checkout"][form="cart"]',
  ].join(', ');
  document.querySelectorAll(checkoutSelectors).forEach((btn) => {
    // Theme loading
    btn.classList.remove('loading');
    btn.removeAttribute('aria-busy');
    btn.querySelector('.loading__spinner')?.classList.add('hidden');
    // Bogos.io Free Gift spinner (cart page button)
    const hasBogosSpinner =
      btn.querySelector('#sca-spinner-checkout, .sca-spinner-border, .sca-loading') ||
      btn.hasAttribute('data-fg-checkout-btn') ||
      btn.getAttribute('value') === 'Loading...';
    if (hasBogosSpinner) {
      btn.innerHTML = 'Checkout';
      btn.removeAttribute('value');
      btn.removeAttribute('sca_handle_checkout');
      // Keep data-fg-checkout-btn so Bogos can still work on next click
    }
    btn.disabled = false;
  });
  const drawer = document.querySelector('cart-drawer');
  const drawerCheckout = document.getElementById('CartDrawer-Checkout');
  if (drawer?.classList.contains('is-empty') && drawerCheckout) {
    drawerCheckout.disabled = true;
  }
  const cartPage = document.querySelector('cart-items');
  const pageCheckout = document.getElementById('checkout');
  if (cartPage?.classList.contains('is-empty') && pageCheckout) {
    pageCheckout.disabled = true;
  }
}
function resetCartDrawerAfterBackNavigation() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  drawer.classList.remove('active', 'animate');
  document.body.classList.remove('overflow-hidden');
}
window.addEventListener('pageshow', (event) => {
  resetCartCheckoutButtons();
  if (event.persisted) resetCartDrawerAfterBackNavigation();
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', resetCartCheckoutButtons);
} else {
  resetCartCheckoutButtons();
}
/* 15072026
function resetCartCheckoutButtons() {
  
  const checkoutSelectors = [
    '#CartDrawer-Checkout',
    'button[name="checkout"][form="CartDrawer-Form"]',
    '#checkout',
    'button[name="checkout"][form="cart"]',
  ].join(', ');

  document.querySelectorAll(checkoutSelectors).forEach((btn) => {
    btn.classList.remove('loading');
    btn.removeAttribute('aria-busy');
    btn.querySelector('.loading__spinner')?.classList.add('hidden');
  });

  const drawer = document.querySelector('cart-drawer');
  const drawerCheckout = document.getElementById('CartDrawer-Checkout');
  if (drawer?.classList.contains('is-empty') && drawerCheckout) {
    drawerCheckout.disabled = true;
  }

  const cartPage = document.querySelector('cart-items');
  const pageCheckout = document.getElementById('checkout');
  if (cartPage?.classList.contains('is-empty') && pageCheckout) {
    pageCheckout.disabled = true;
  }
}

function resetCartDrawerAfterBackNavigation() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  drawer.classList.remove('active', 'animate');
  document.body.classList.remove('overflow-hidden');
  resetCartCheckoutButtons();
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted) resetCartDrawerAfterBackNavigation();
});




window.addEventListener('pageshow', (event) => {
  resetCartCheckoutButtons();
  if (event.persisted) resetCartDrawerAfterBackNavigation();
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', resetCartCheckoutButtons);
} else {
  resetCartCheckoutButtons();
}
*/
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    resetCartCheckoutButtons();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
